<template>
  <section id="WheelNavigation">
    <transition name="fade-in">
      <article v-if="ready">
        <nav>
          <button
            class="WheelNavigation__button WheelNavigation__button--prev"
            @click="wheelPrev"
          ></button>
          <button
            class="WheelNavigation__button WheelNavigation__button--next"
            @click="wheelNext"
          ></button>
        </nav>
        <section v-for="wedge in visibleWheel" :key="wedge.id">
          <img :src="getMediaPath(wedge.desktopImage.src)" />
          <div v-if="wedge.index == activeWedge">
            <h1 v-html="wedge.title"></h1>
            <div v-html="wedge.subtitle"></div>
            <router-link :to="getRouteFromID(wedge.sceneLink)" @click="trackStartClick(wedge.title)" class="Button"
              >Start</router-link
            >
          </div>
        </section>
      </article>
    </transition>
  </section>
</template>
<script>
export default {
  props: ["properties", "pageData"],
  data() {
    return {
      wheel: [],
      activeWedge: 0,
      showText: false,
      ready: false,
    };
  },
  created() {
    this.prepareWheel();
  },
  mounted() {
    this.initHammer();
    this.ready = true;
    window.addEventListener("keydown", this.keydownHandler);
  },
  destroyed() {
    window.removeEventListener("keydown", this.keydownHandler);
  },
  methods: {
    trackStartClick(wedgeTitle) {
      var payload = {
        event: 'future_spin_choose_level',
        title: wedgeTitle,
      };
      app.api.Tracking.event("trackEvent", "future_spin_choose_level", payload);
    },
    prepareWheel() {
      this.wheel = this.properties.wheels.map((wedge, i) => {
        wedge.index = i;
        wedge.id = `wedge__${i}`;
        return wedge;
      });
    

      if(this.$store.state.previousRoute) {
        let prevID = app.manifest.getPage(this.$store.state.previousRoute).id;
        let matchedWedge = this.wheel.find(wedge => {
          return wedge.sceneLink == prevID;
        })

        this.activeWedge = matchedWedge ? matchedWedge.index : this.getRandomStartWedge();
        if(!matchedWedge) {
          setTimeout(() => {
            this.wheelNext();
          }, 1);
        }
      }
    },
    initHammer() {
      var element = document.getElementById("WheelNavigation");
      var mc = new Hammer(element);
      var t = this;

      mc.on("swipeleft swiperight", function (ev) {
        switch (ev.type) {
          default:
            if (ev.type == "swipeleft") {
              t.wheelNext();
            } else if (ev.type == "swiperight") {
              t.wheelPrev();
            }
            break;
        }
      });
    },
    wheelPrev() {
      this.activeWedge != 0
        ? (this.activeWedge -= 1)
        : (this.activeWedge = this.wheel.length - 1);
    },
    wheelNext() {
      this.activeWedge != this.wheel.length - 1
        ? (this.activeWedge += 1)
        : (this.activeWedge = 0);
    },
    keydownHandler(e) {
      switch (e.key) {
        case "ArrowLeft":
          this.wheelPrev();
          return;
        case "ArrowRight":
          this.wheelNext();
          return;
      }
    },
    getRandomStartWedge() {
      let length = this.wheel.length - 1;

      return Math.floor(Math.random() * length);
    },

    getMediaPath(src) {
      return app.manifest.getMediaPath(src)
    },
    getRouteFromID(id) {
      return app.manifest.getRouteFromID(id);
    },
  },
  computed: {
    visibleWheel() {
      let newWheel = [];

      //get wedges to the left
      if (this.activeWedge === 0) {
        newWheel.push(this.wheel[this.wheel.length - 2]);
        newWheel.push(this.wheel[this.wheel.length - 1]);
      } else if (this.activeWedge === 1) {
        newWheel.push(this.wheel[this.wheel.length - 1]);
        newWheel.push(
          this.wheel[
            this.wheel.findIndex((item) => item.index == this.activeWedge - 1)
          ]
        );
      } else {
        newWheel.push(
          this.wheel[
            this.wheel.findIndex((item) => item.index == this.activeWedge - 2)
          ]
        );
        newWheel.push(
          this.wheel[
            this.wheel.findIndex((item) => item.index == this.activeWedge - 1)
          ]
        );
      }

      //get "activeWedge"
      newWheel.push(
        this.wheel[
          this.wheel.findIndex((item) => item.index == this.activeWedge)
        ]
      );

      //get wedges to the right
      if (this.activeWedge + 2 < this.wheel.length) {
        newWheel.push(
          this.wheel[
            this.wheel.findIndex((item) => item.index == this.activeWedge + 1)
          ]
        );
        newWheel.push(
          this.wheel[
            this.wheel.findIndex((item) => item.index == this.activeWedge + 2)
          ]
        );
      } else if (this.activeWedge + 1 < this.wheel.length) {
        newWheel.push(
          this.wheel[
            this.wheel.findIndex((item) => item.index == this.activeWedge + 1)
          ]
        );
        newWheel.push(this.wheel[0]);
      } else {
        newWheel.push(this.wheel[0]);
        newWheel.push(this.wheel[1]);
      }

      return newWheel;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/sass/_responsiveness.scss";

#WheelNavigation {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background: var(--main-color);

  & > article {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    nav {
      display: flex;
      justify-content: space-between;
      position: relative;
      width: 100%;
      max-width: 1580px;
      padding: 0 40px;
      z-index: 3;
      pointer-events: none;

      .WheelNavigation__button {
        width: 60px;
        height: 60px;
        cursor: pointer;
        border-radius: 1000px;
        background-image: url(@/assets/img/ui/btn-next-dark.svg);
        background-position: center;
        background-repeat: no-repeat;
        transition: var(--tk-easeinout) 0.1s transform;
        pointer-events: all;

        &.WheelNavigation__button--prev {
          left: 0;
          rotate: 180deg;
        }

        &.WheelNavigation__button--next {
          right: 0;
        }

        &:hover {
          transform: scale(1.05);
        }
      }
    }

    & > section {
      position: absolute;
      transition-property: transform;
      transition-timing-function: var(--tk-easeinout);
      transition-duration: 0.3s;
      transform-origin: 50% 100%;
      z-index: 1;

      & > img {
        min-height: 95vw;
        pointer-events: none;
      }

      & > div {
        position: absolute;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 540px;
        left: 50%;
        top: 45%;
        transform: translateX(-50%) translateY(-50%);
        color: #fff;
        opacity: 0;

        animation-name: fadeInUp;
        animation-duration: 0.7s;
        animation-timing-function: var(--tk-easeinout);
        animation-fill-mode: forwards;
        animation-delay: 0.3s;

        h1 {
          font-size: 57px;
          font-weight: 700;
          margin-bottom: 25px;
        }

          &>div{
            display: flex;
            justify-content: center;
            p {
              font-size: 16px;
              line-height: 22px;
              width: 60%;
              margin-bottom: 35px;
            }
          }

        a.Button {
          color: #000;
          background: #fff;
        }
      }

      &:nth-of-type(1) {
        transform: rotate(-90.5deg);
      }

      &:nth-of-type(2) {
        transform: rotate(-47deg);
      }

      &:nth-of-type(3) {
        z-index: 2;
      }

      &:nth-of-type(4) {
        transform: rotate(47deg);
      }

      &:nth-of-type(5) {
        transform: rotate(90.5deg);
      }
    }
  }

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 150px;
    height: 75px;
    background-image: url(@/assets/img/ui/drag-drop-icon.svg);
    background-position: center;
    background-repeat: no-repeat;
    z-index: 2;
  }

  @include mobile-only {
    .WheelNavigation__button {
      display: none;
    }

    & > article {
      & > section {
        & > img {
            height: 125vh;
        }

        & > div {
        top: 46%;
        width: 80vw;
          h1 {
            font-size: 38px;
            margin-bottom: 15px;
          }
        }
      }
    }
  }

  @include tablet-down {
    & > article {
      & > section {
        & > img {
            height: 140vh;
        }
      }
    }
  }
}

@-webkit-keyframes fadeInUp {
  from {
    opacity: 0;
    -webkit-transform: translateX(-50%) translateY(-45%);
    transform: translateX(-50%) translateY(-45%);
  }

  to {
    opacity: 1;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    -webkit-transform: translateX(-50%) translateY(-45%);
    transform: translateX(-50%) translateY(-45%);
  }

  to {
    opacity: 1;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }
}
</style>